import axios, { AxiosError } from 'axios';

export const apiClient = axios.create({
    withCredentials: true,
    headers: {
        Accept: 'application/json',
    },
});

export function isAxiosError<T>(error: any): error is AxiosError<T> {
    return error.isAxiosError;
}
